import loginModule from '../loginModule';

const loginConstants = {
    urls: {
        metaData: "/login/meta-data",
        loginApi: "/v2/login",
        credentialsVerificationApi: "/v2/credentials/verification", // GET - determines if verification email can be sent
        credentialsVerificationSendApi: "/v2/credentials/verification/send", // POST - sends verification email
        loginCaptchaApi: "/captcha/validate/login",
        twoStepVerification: "/login/twostepverification",
        forgotCredentials: "/login/forgot-password-or-username",
        games: "/games",
        home: "/home",
        securityNotification: "/login/securityNotification",
        login: "/login",
        redirectToFb: "/social/redirect-to-facebook",
        signUpRedirect: "/account/signupredir",
        authTokenMetadata: "/auth-token-service/v1/login/metadata"
    },
    templates: {
        verifyEmail: "verify-email"
    },
    controllers: {
        verifyEmail: "verifyEmailController"
    },
    errorCodes: {
        unknownError: 0,
        badCredentials: 1,
        captcha: 2,
        accountNotFound: 3,
        passwordResetRequired: 4,
        noPassword: 5,
        accountIssue: 6,
        tooManyAttempts: 7,
        defaultLoginRequired: 9,
        unverifiedCredentials: 10,
        captchaLoadFailed: 11,
        captchaVerifyFailed: 12,
        captchaUnknownError: 13,
        luoBuUserDenied: 14
    },
    sendVerificationEmailErrorCodes: {
        tooManyAttempts: 2
    },
    statusCodes: {
        flooded: 429
    },
    credentialTypes: {
        username: "Username",
        email: "Email",
        phone: "PhoneNumber",
        authToken: "AuthToken"
    },
    urlQueryNames: {
        errorCode: "errorCode",
        cType: "ctype",
        username: "username",
        samlRequest: "samlRequest",
        samlRelayState: "samlRelayState"
    },
    counters: {
        prefix: "WebsiteLogin_",
        firstAttempt: "FirstAttempt",
        attempt: "Attempt",
        success: "Success",
        captcha: "Captcha",
        passwordResetRequired: "PasswordResetRequired",
        unverifiedAccount: "UnverifiedAccount",
        invalidCredentials: "InvalidCredentials",
        accountNotFound: "AccountNotFound",
        noPassword: "NoPassword",
        accountIssue: "AccountIssue",
        tooManyAttempts: "TooManyAttempts",
        defaultLoginRequired: "DefaultLoginRequired",
        redirectToLogin: "RedirectToLogin",
        captchaLoadFailed: "CaptchaLoadFailed",
        captchaVerifyFailed: "CaptchaVerifyFailed",
        captchaUnknownError: "CaptchaUnknownError",
        luoBuUserDenied: "LuoBuUserDenied",
        unknownError: "UnknownError"
    },
    newLoginQueryString: "nl=true",
    loginSubmitButtonName: "loginSubmit",
    quickLoginButtonName: "loginOtherDevice",
    fbLoginButtonName: "fbLoginSubmit",
    landingContext: "landing",
    atSymbol: "@",
    verifyEmailContextSuffix: "_verifyEmail"
}

loginModule.constant("loginConstants", loginConstants);

export default loginConstants;